export default __webpack_public_path__ + "static/media/waterfall.65ce2cec994bd324d888ddb599795ae1.jpg";